import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import thinkGreen from './thinkgreen.png';

class Footer extends Component {

  render() {
    return (
        <div className="footer-outer">
            <footer className="container">
                <div className="row">
                    <div className="col-sm-9 contact">
                        <span>136 Durham Drive, Coatesville, PA 19320</span>
                        <span>[p] <strong className="spread">484-343-5176</strong></span>
                        <span>[f] <strong className="spread">610-857-1186</strong></span>
                    </div>
                    <div className="col-sm-3 thinkGreen">
                        <Link to="/environment">
                            <img src={thinkGreen} alt="Think Green" />
                        </Link>
                    </div>
                </div>
            </footer>
        </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js